import { FREE_PLAN_PACKAGE_NAMES } from '@/constants/packages';
import { useAppSelector } from '@/redux/store';

/**
 * Hook to determine if the current organization is on a free (or HR-free) plan.
 * The API doesn't guarantee organizationPackages ordering, so instead of
 * assuming index 0 is the "current" package, this checks that every
 * attached package is a free-plan package — a leftover free package on an
 * otherwise-paid org still won't count as "free plan".
 * // TODO(TF-677): replace with gigawatt_setup_assistant entitlement once core-entity ships it
 * @returns {boolean} True if the organization has at least one package and all of them are free-plan packages, false otherwise.
 */
export const useIsFreePlanOrganization = (): boolean => {
  const packages =
    useAppSelector(state => state.loggedUser?.organizationPackages) || [];

  const freePlanPackageNames: string[] = FREE_PLAN_PACKAGE_NAMES;

  return (
    packages.length > 0 &&
    packages.every(pkg => freePlanPackageNames.includes(pkg.package.name))
  );
};
